import { call, put, takeLatest } from 'redux-saga/effects'
import { getSession, startCall, stopCall } from './actions'
import { apiCreateSession, apiGetSession, apiEndSession } from './services'
import { STOP_CALL, GET_SESSION, START_CALL } from './constants'
import { getCustomer } from '../../helpers'
import * as KEYS from '../../constants/keys'

function* stopCallWorker({ data }) {
  try {
    yield call(apiEndSession, data)
    yield put(stopCall.success())
  } catch (error) {
    // fallback if API does not work
    yield put(stopCall.success())
  }
}

function* startCallWorker({ data }) {
  try {
    const response = yield call(apiCreateSession, {
      ...data,
      startTime: new Date().getTime()
    })
    yield put(startCall.success(response))
  } catch (e) {
    //fallback if for some reason Redis is not working
    yield put(startCall.success(data))
  }
}
function* getSessionWorker({ userId }) {
  try {
    const response = yield call(apiGetSession, userId)
    if (response && response.engagementID) {
      const { engagementID, customer } = response
      /* check if current customer is the same as in open call, in case there are multiple customers
      with call capabilities enabled */
      if (customer !== getCustomer()) {
        // switch to customer which has open call
        sessionStorage.setItem('customer', customer)
        window.location.replace(
          `${window.location.origin}?customer=${customer}`
        )
      }
      sessionStorage.setItem(KEYS.CALL_SESSION_ID, engagementID)
    }
    yield put(getSession.success(response))
  } catch (e) {
    // yield put(getSession(e.message))
  }
}

export default function* watcher() {
  yield takeLatest(GET_SESSION.REQUEST, getSessionWorker)
  yield takeLatest(START_CALL.REQUEST, startCallWorker)
  yield takeLatest(STOP_CALL.REQUEST, stopCallWorker)
}
